<template>
  <transition name="el-zoom-in-center">
    <el-card class="box-card" style="text-align: left;" v-show="add.addshow">
      <div slot="header" class="clearfix">
        <el-row>
          <el-col :span="12">
            <h3>新增规则</h3>
          </el-col>
          <el-col :span="12">
            <el-button style="float: right;" type="primary" @click="add.addshow=false">收起</el-button>
          </el-col>
        </el-row>
      </div>
      <el-form ref="form" :model="form" label-width="120px" style="width:100%" :rules="rules">
        <el-row>
          <el-col :span="6">
            <el-form-item label="规则名称" prop="rule_name">
              <el-input v-model="form.rule_name" style="width:90%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="单次最大生码量" prop="rule_max">
              <el-input v-model.number="form.rule_max" style="width:90%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="规则链接" prop="rule_link">
              <el-input v-model="add.rule_link" style="width:90%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="产品编码" prop="product_code">
              <el-select
                v-model="form.product_code"
                placeholder="请输入产品名称模糊匹配或者下拉选择"
                style="width:90%"
                :remote-method="getproductlist"
                filterable
                remote
                :loading="productloading"
                :disabled="bool"
              >
                <el-option
                  v-for="item in productlist"
                  :key="item.product_code"
                  :label="item.product"
                  :value="item.product_code"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div>
        <!-- 填写具体奖项 -->
        <h4>规则明细</h4>
        <br />
        <el-row>
          <el-col :span="10">
            <el-card shadow="never">
              <el-form
                ref="ruleform"
                :model="ruleform"
                label-width="140px"
                style="width:90%"
                :rules="rules"
              >
                <el-form-item label="明细名称" prop="rule_name">
                  <el-select
                    type="text"
                    v-model="ruleform.rule_name"
                    style="width:80%"
                    @change="rulenamechange(ruleform,$event)"
                  >
                    <el-option
                      v-for="item in rule_name"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="类型" prop="rule_type">
                  <el-select
                    type="text"
                    :disabled="typehide"
                    @change="typechange(ruleform,$event)"
                    v-model="ruleform.rule_type"
                    style="width:80%"
                  >
                    <el-option
                      v-for="item in rule_type"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="内容" prop="rule_content">
                  <el-input
                    v-show="ruleform.rule_name!==2&&ruleform.rule_name!==3"
                    v-model="ruleform.rule_content"
                    @change="contentchange(ruleform)"
                    :disabled="contenthide"
                    style="width:80%"
                  ></el-input>
                  <el-select
                    v-model="ruleform.rule_content"
                    v-show="ruleform.rule_name==3"
                    placeholder="请选择产品简码或输入产品名称模糊匹配"
                    :remote-method="getproductlistcode"
                    @change="contentchange(ruleform)"
                    filterable
                    remote
                    :loading="productloading"
                    style="width:80%"
                  >
                    <el-option
                      v-for="item in productlist"
                      :key="item.product_short_code"
                      :label="item.product_short_code"
                      :value="item.product_short_code"
                    />
                  </el-select>
                  <el-select
                    v-model="ruleform.rule_content"
                    placeholder="请选择包装级别"
                    v-show="ruleform.rule_name==2"
                    @change="getlink"
                  >
                    <el-option
                      v-for="item in contenttype"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="长度" prop="rule_length">
                  <el-input
                    v-model.number="ruleform.rule_length"
                    :disabled="lengthhide"
                    style="width:80%"
                  ></el-input>
                </el-form-item>
              </el-form>
              <div style="text-align: center;">
                <el-button style="margin-top: 12px;" @click="resetForm('ruleform')">重置</el-button>
                <el-button
                  style="margin-top: 12px;"
                  type="primary"
                  @click="productadd('ruleform')"
                >生成</el-button>
              </div>
            </el-card>
          </el-col>
          <el-col :span="2" style="text-align:center">
            <el-button size="medium" style="margin-top: 100px;" class="el-icon-d-arrow-right"></el-button>
          </el-col>
          <el-col :span="11">
            <el-card shadow="never">
              <el-table :data="form.qrcodeRule" stripe style="width: 100%" height="224">
                <el-table-column type="index" width="50"></el-table-column>
                <el-table-column prop="rule_namemean" label="明细名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="rule_typename" label="规则类型" show-overflow-tooltip></el-table-column>
                <el-table-column prop="rule_content" label="规则内容" min-width="100"></el-table-column>
                <el-table-column prop="rule_length" label="规则长度" min-width="140"></el-table-column>
                <el-table-column prop="address" label="操作" width="80" fixed="right">
                  <template slot-scope="scope">
                    <el-button-group>
                      <el-button
                        type="danger"
                        @click.native.prevent="deleteRow(scope.$index, form.qrcodeRule)"
                      >删除</el-button>
                    </el-button-group>
                  </template>
                </el-table-column>
              </el-table>
            </el-card>
          </el-col>
        </el-row>
        <div style="text-align: center;">
          <el-button style="margin-top: 12px;" type="primary" @click="submitadd('form')">提交</el-button>
        </div>
      </div>
    </el-card>
  </transition>
</template>
<script>
import { codeadd } from "@/api/tagging";
import { buildcodeurllist, productlist, shortcode } from "@/api/base";
export default {
  props: {
    search: {
      type: Function,
      default: null
    },
    add: {
      type: Object,
      default: () => {
        return {
          rule_link: null,
          addshow: null
        };
      }
    }
  },
  data() {
    return {
      //基础数据
      typehide: true,
      lengthhide: true,
      contenthide: true,
      bool: false,
      productloading: true,
      productlist: [], //产品列表下拉
      contenttype: [
        {
          value: 1,
          label: "一级包装"
        },
        {
          value: 2,
          label: "二级包装"
        }
      ],
      rule_name: [
        {
          value: 1,
          label: "生码日期"
        },
        {
          value: 2,
          label: "包装级别"
        },
        {
          value: 3,
          label: "产品简码"
        },
        {
          value: 4,
          label: "自增长"
        },
        {
          value: 5,
          label: "自定义"
        },
        {
          value: 6,
          label: "企业编码"
        },
        {
          value: 7,
          label: "版本号"
        }
      ],
      rule_type: [
        {
          value: 1,
          label: "年月日"
        },
        {
          value: 2,
          label: "输入固定字符"
        },
        {
          value: 3,
          label: "自增长数字"
        },
        {
          value: 4,
          label: "不重复随机数字"
        },
        {
          value: 5,
          label: "不重复随机数字+字母"
        }
      ],
      show: true,
      form: {
        rule_name: null,
        rule_link: null,
        rule_max: null,
        product_code: null,
        qrcodeRule: []
      },
      ruleform: {
        rule_id: null,
        rule_name: null,
        rule_namemean: null,
        rule_type: null,
        rule_typename: null,
        rule_content: null,
        rule_length: null
      },
      rules: {
        rule_name: [
          { required: true, message: "请输入规则名称", trigger: "blur" }
          // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ],
        rule_length: [
          { required: true, message: "长度不能为空", trigger: "blur" },
          { type: "number", message: "请输入数字" }
        ],
        rule_max: [{ type: "number", message: "请输入数字" }],
        product_code: [
          { required: true, message: "请选择产品编码", trigger: "blur" }
        ]
      },
      dialogVisible: false
    };
  },
  mounted() {
    this.getproductlist();
    this.getlink(1);
  },
  methods: {
    // 获取产品下拉
    getproductlist(value) {
      this.productlist = [];
      if (value !== "") {
        this.productloading = true;
        setTimeout(() => {
          this.productloading = false;
          productlist({ productName: value }).then(response => {
            this.productlist = response.data.data;
            for (var i = 0; i < this.productlist.length; i++) {
              this.productlist[i].product =
                this.productlist[i].product_code +
                "   " +
                this.productlist[i].product_name;
            }
          });
        }, 200);
      } else {
        this.productlist = [];
      }
    },
    // 获取产品简码下拉
    getproductlistcode(value) {
      this.productlist = [];
      if (value !== "") {
        this.productloading = true;
        setTimeout(() => {
          this.productloading = false;
          productlist({ productShortCode: value }).then(response => {
            this.productlist = response.data.data;
            console.log(this.productlist);
          });
        }, 200);
      } else {
        this.productlist = [];
      }
    },
    getlink(link) {
      this.dialogVisible = true;
      buildcodeurllist({ package_level: link }).then(res => {
        console.log(res.data);
        this.add.rule_link = res.data[0].url + "" + res.data[0].suffix;
      });
    },
    // 把产品添加到表格
    productadd(formName) {
      this.$refs[formName].validate(valid => {
        if (this.ruleform.rule_name == 2 || this.ruleform.rule_name == 3) {
          // 名称为保证级别时候内容不能为空
          if (!this.ruleform.rule_content) {
            this.$message({
              type: "warning",
              message: "内容不能为空"
            });
            return;
          }
        }
        if (this.ruleform.rule_name == 3) {
          if (!this.form.product_code) {
            this.$message({
              type: "warning",
              message: "请输入正确的产品简码"
            });
            return;
          }
        }
        if (valid) {
          const obj = {};
          obj["rule_name"] = this.ruleform.rule_name;
          obj["rule_namemean"] = this.ruleform.rule_namemean;
          obj["rule_type"] = this.ruleform.rule_type;
          obj["rule_typename"] = this.ruleform.rule_typename;
          obj["rule_content"] = this.ruleform.rule_content;
          obj["rule_length"] = this.ruleform.rule_length;
          for (let i = 0; i < this.form.qrcodeRule.length; i++) {
            // 判断明细名称不能重复
            if (this.ruleform.rule_name !== 5) {
              if (
                this.form.qrcodeRule[i].rule_name == this.ruleform.rule_name
              ) {
                this.$message({
                  type: "warning",
                  message: "明细名称不能重复添加"
                });
                return;
              }
            }
          }

          if (this.ruleform.rule_name == 3) {
            this.bool = true;
          }
          this.form.qrcodeRule.push(obj);
          console.log(this.form.qrcodeRule);
          this.$refs[formName].resetFields();
        } else {
          return false;
        }
      });
    },
    // 表格行删除
    deleteRow(index, rows) {
      if (rows[index].rule_name == 3) {
        this.bool = false;
        this.getproductlist();
        this.form.product_code = null;
      }
      rows.splice(index, 1);
    },
    rulenamechange(obj, e) {
      let tamp = {};
      tamp = this.rule_name.find(item => {
        return item.value === e; //筛选出匹配名称的label
      });
      this.ruleform.rule_namemean = tamp.label;
      switch (obj.rule_name) {
        case 1:
          this.bool = false;
          obj.rule_type = 1;
          this.typehide = true;
          obj.rule_length = 5;
          this.lengthhide = true;
          obj.rule_content = "";
          this.contenthide = true;
          break;
        case 2:
          this.bool = false;
          obj.rule_type = 2;
          this.typehide = true;
          obj.rule_length = 1;
          this.lengthhide = true;
          obj.rule_content = "";
          break;
        case 3:
          this.bool = true;
          obj.rule_type = 2;
          this.typehide = true;
          this.contenthide = false;
          obj.rule_content = "";
          obj.rule_length = null;
          // this.form.product_code = null;
          break;
        case 4:
          this.bool = false;
          obj.rule_type = 3;
          this.typehide = true;
          obj.rule_length = 1;
          this.lengthhide = true;
          obj.rule_content = "";
          this.contenthide = true;
          break;
        case 5:
          this.bool = false;
          this.typehide = false;
          this.contenthide = true;
          obj.rule_content = "";
          this.contenthide = true;
          break;
        case 6:
          this.bool = false;
          obj.rule_type = 2;
          this.typehide = true;
          this.contenthide = false;
          obj.rule_content = "";
          obj.rule_length = null;
          break;
        case 7:
          this.bool = false;
          obj.rule_type = 2;
          this.typehide = true;
          this.contenthide = false;
          obj.rule_content = "";
          obj.rule_length = null;
          break;
        default:
          break;
      }
      for (let i = 0; i < this.form.qrcodeRule.length; i++) {
        if (this.form.qrcodeRule[i].rule_name == 3) {
          this.bool = true;
        }
      }
      switch (
        obj.rule_type // 获取类型名称
      ) {
        case 1:
          obj.rule_typename = "年月日";
          break;
        case 2:
          obj.rule_typename = "输入固定字符";
          break;
        case 3:
          obj.rule_typename = "自增长数字";
          break;
        case 4:
          obj.rule_typename = "不重复随机数";
          break;
        default:
          break;
      }
    },
    typechange(obj, e) {
      // 明细名称改变时
      let tamp = {};
      tamp = this.rule_type.find(item => {
        return item.value === e; //筛选出匹配名称的label
      });
      this.ruleform.rule_typename = tamp.label;
      switch (obj.rule_type) {
        case 1:
          obj.rule_length = 5;
          this.lengthhide = true;
          obj.rule_content = "";
          this.contenthide = true;
          break;
        case 2:
          obj.rule_length = 1;
          this.lengthhide = true;
          obj.rule_content = "";
          this.contenthide = false;
          break;
        case 3:
          this.contenthide = false;
          obj.rule_content = "";
          this.contenthide = true;
          obj.rule_length = 1;
          break;
        case 4:
          this.lengthhide = false;
          obj.rule_content = "";
          this.contenthide = true;
          break;
        case 5:
          this.lengthhide = false;
          obj.rule_content = "";
          this.contenthide = true;
          break;
        case 6:
          this.contenthide = false;
          obj.rule_content = "";
          this.contenthide = true;
          break;
        case 7:
          this.contenthide = false;
          obj.rule_content = "";
          this.contenthide = true;
          break;

        default:
          break;
      }
    },
    // 明细内容变化
    contentchange(obj) {
      obj.rule_length = obj.rule_content.length;
      if (obj.rule_name === 3) {
        this.productlist = [];
        shortcode({ product_short_code: obj.rule_content }).then(res => {
          if (res.data == null) {
            this.form.product_code = "";
            return;
          }
          // 获取产品下拉
          if (obj.rule_content !== "") {
            this.productlist.push(res.data);
            for (var i = 0; i < this.productlist.length; i++) {
              this.productlist[i].product =
                this.productlist[i].product_code +
                "   " +
                this.productlist[i].product_name;
            }
            this.form.product_code = this.productlist[0].product_code;
          } else {
            this.productlist = [];
          }
        });
      }
    },
    //保存提交
    submitadd(formName) {
      this.$refs[formName].validate(valid => {
        //基础表单验证
        if (valid) {
          for (let i = 0; i < this.form.qrcodeRule.length; i++) {
            this.form.qrcodeRule[i]["rule_sort"] = i + 1;
          }
          this.form.rule_link = this.add.rule_link;
          codeadd(this.form).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "添加成功!"
              });
              this.search();
              this.form.qrcodeRule = [];
              this.add.addshow = false;
              this.resetForm("form");
            } else {
              this.$message({
                type: "warning",
                message: "添加失败!请检查字段"
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 清空表单数据
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
